import { SVGProps } from 'react';

const RefreshCwOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 8-2.26-2.26A9.75 9.75 0 0 0 12 3c-1 0-1.97.16-2.87.47M16 8h5V3M3 21v-5h5m-5 0 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64M3 12c0-2.49 1-4.74 2.64-6.36M21 12c0 1-.16 1.97-.47 2.87M22 22 2 2"
    />
  </svg>
);
export default RefreshCwOff;
